
export default {
  name: 'BaseProfileAuthorRatings',
  props: {
    ratings: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: 'Рейтинги',
    },
    authorId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isShowLoadMoreButton: false,
      elementsCount: 3,
    }
  },
  computed: {
    isAuthor() {
      if (this.$auth.loggedIn && this.authorId) {
        return this.$auth?.user?._id === this.authorId
      } else {
        return false
      }
    },
    croppedRatings() {
      const ratings = [...this.ratings].reverse()
      return ratings.slice(0, this.elementsCount)
    },
  },
  mounted() {
    this.isShowLoadMoreButton = this.ratings?.length > this.elementsCount
  },
  methods: {
    showMore() {
      this.elementsCount = this.ratings.length
      this.isShowLoadMoreButton = false
    },
  },
}
